import constate from "constate";
import { useState } from "react";
import { GroupShiftInvite, ShiftInviteInfo } from "../ShiftInviteReview";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlag } from "@src/constants/FEATURE_FLAGS";
import { useShiftTimes } from "@src/containers/postShifts/hooks/useShiftTimes";
import { SessionType } from "@src/modules/interface";
import { useSelector } from "react-redux";
import { DEFAULT_TIMEZONE } from "@src/constants/timezone";

interface UseShiftInviteParams {
  agentReq: string;
}

function useShiftInvite(params: UseShiftInviteParams) {
  const { agentReq } = params;
  const ldFlags = useFlags();
  const { profile } = useSelector((state: SessionType) => state.session);
  const workplaceId = profile?.userId;
  const facilityTimeZone = profile?.tmz ?? DEFAULT_TIMEZONE;
  const { data: shiftTimes } = useShiftTimes(workplaceId);
  const isMultiShiftInvitesEnabled = ldFlags[FeatureFlag.ROLLOUT_MULTI_SHIFT_INVITES] ?? false;
  const [groupedShiftInvite, setGroupedShiftInvite] = useState<GroupShiftInvite>({
    workplaceId,
    agentReq,
    tmz: facilityTimeZone,
    postShiftToMarketplace: true,
    multipleShiftInfo: new Map<string, ShiftInviteInfo>(),
  });

  return {
    groupedShiftInvite,
    setGroupedShiftInvite,
    isMultiShiftInvitesEnabled,
    shiftTimes,
  };
}

export const [ShiftInviteProvider, useShiftInviteContext] = constate(useShiftInvite);
